// UPost.com - Authentication Context
import React, { createContext, useContext, useState, useEffect } from 'react';
import { api } from '../utils/api';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Check if user is logged in
    const token = localStorage.getItem('token');
    if (token) {
      api.setToken(token);
      loadUser();
    } else {
      setLoading(false);
    }
  }, []);

  async function loadUser() {
    try {
      const userData = await api.getCurrentUser();
      setUser(userData);
    } catch (err) {
      console.error('Failed to load user:', err);
      api.clearToken();
    } finally {
      setLoading(false);
    }
  }

  async function register(email, password, fullName, referralCode = null) {
    setError(null);
    try {
      const response = await api.register(email, password, fullName, referralCode);
      api.setToken(response.token);
      setUser(response.user);
      return response;
    } catch (err) {
      setError(err.message);
      throw err;
    }
  }

  async function login(email, password, twoFactorCode = null) {
    setError(null);
    try {
      const response = await api.login(email, password, twoFactorCode);
      if (response.requires_2fa) {
        return response;
      }
      api.setToken(response.token);
      setUser(response.user);
      return response;
    } catch (err) {
      setError(err.message);
      throw err;
    }
  }

  function logout() {
    api.clearToken();
    setUser(null);
  }

  const value = {
    user,
    loading,
    error,
    register,
    login,
    logout,
    refreshUser: loadUser,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}